module.exports = __webpack_public_path__ + "static/media/new-all3d-white.08aa546f.svg";